(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var wrap = document.querySelector('[data-hero-video]');
    if (!wrap) return;
    var video = wrap.querySelector('video');
    var toggle = wrap.querySelector('[data-hero-toggle]');
    if (!video) return;

    function setState(playing) {
      wrap.setAttribute('data-playing', playing ? 'true' : 'false');
      if (toggle) {
        toggle.setAttribute('aria-pressed', playing ? 'true' : 'false');
        toggle.setAttribute('aria-label', playing ? toggle.getAttribute('data-label-pause') : toggle.getAttribute('data-label-play'));
      }
    }
    function play() {
      var p = video.play();
      if (p && p.then) {
        p.then(function () { setState(true); }).catch(function () { setState(false); });
      } else {
        setState(true);
      }
    }
    function pause() {
      video.pause();
      setState(false);
    }

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (!reduce.matches) {
      play();
    } else {
      setState(false);
    }
    if (toggle) {
      toggle.addEventListener('click', function () {
        if (video.paused) { play(); } else { pause(); }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var knop = event.target.closest('[data-vr-toggle]');
    if (!knop) return;

    var grid = document.getElementById(knop.dataset.vrToggle);
    if (!grid) return;

    grid.classList.remove('vr__grid--ingeklapt');

    // Zet de focus op de eerste nieuw zichtbare kaart, zodat wie met het
    // toetsenbord navigeert niet terugvalt naar de bovenkant van de pagina.
    var eerste = grid.querySelector('.vr__card--extra');
    if (eerste) {
      eerste.setAttribute('tabindex', '-1');
      eerste.focus({ preventScroll: true });
    }

    knop.parentElement.remove();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-koopbalk"] && !Shopify.designMode) return;
  try {
    
  class StickyKoopbalk extends HTMLElement {
    connectedCallback() {
      this.doel = document.querySelector(this.dataset.doel);
      this.hidden = false;

      // Zonder de gewone koopknoppen op de pagina heeft de balk geen ijkpunt;
      // dan blijft hij weg in plaats van permanent in beeld te staan.
      if (!this.doel) return;

      // Bewust een scrollberekening en geen IntersectionObserver: die vuurt
      // niet betrouwbaar bij directe sprongen (ankerlinks, terug naar boven),
      // waardoor de balk kon blijven hangen. Dit leest de stand altijd vers.
      this.bijwerken = this.bijwerken.bind(this);
      this.gepland = false;
      this.plan = () => {
        if (this.gepland) return;
        this.gepland = true;
        requestAnimationFrame(() => {
          this.gepland = false;
          this.bijwerken();
        });
      };

      window.addEventListener('scroll', this.plan, { passive: true });
      window.addEventListener('resize', this.plan, { passive: true });
      this.bijwerken();
      this.koppelPrijs();
      this.koppelKleur();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.plan);
      window.removeEventListener('resize', this.plan);
      if (this.klikErnaast) document.removeEventListener('click', this.klikErnaast);
    }

    bijwerken() {
      // Tonen zodra de koopknoppen volledig boven het scherm liggen.
      var rect = this.doel.getBoundingClientRect();
      var zichtbaar = rect.bottom < 0;
      this.classList.toggle('is-zichtbaar', zichtbaar);
      // Schuift de balk weg terwijl het kleurmenu open staat, dan gaat het
      // menu mee dicht in plaats van los in beeld te blijven hangen.
      if (!zichtbaar && this.menu) this.menu.open = false;
    }

    koppelPrijs() {
      var prijs = this.querySelector('[data-skb-prijs]');
      if (!prijs) return;

      // De prijs in de balk volgt de keuze in de balk zelf, los van de
      // variantkiezer hogerop de pagina. Werkt voor zowel het kleurmenu als
      // de keuzelijst, omdat beide data-prijs meedragen.
      this.addEventListener('change', (event) => {
        var bron = event.target;
        if (bron.tagName === 'SELECT') bron = bron.options[bron.selectedIndex];
        if (bron && bron.dataset && bron.dataset.prijs) prijs.textContent = bron.dataset.prijs;
      });
    }

    koppelKleur() {
      var menu = this.querySelector('[data-skb-kleur]');
      if (!menu) return;
      this.menu = menu;
      var knop = menu.querySelector('summary');
      var staal = menu.querySelector('[data-skb-staal]');
      var naam = menu.querySelector('[data-skb-naam]');

      // Na een keuze toont de knop de gekozen kleur en gaat het menu dicht.
      this.addEventListener('change', (event) => {
        var radio = event.target;
        if (!radio.classList || !radio.classList.contains('skb__radio')) return;
        var label = this.querySelector('label[for="' + radio.id + '"]');
        if (label) {
          var bronStaal = label.querySelector('.swatch');
          if (bronStaal && staal) staal.replaceChildren(bronStaal.cloneNode(true));
          var bronNaam = label.querySelector('.skb__pil-naam');
          if (bronNaam && naam) naam.textContent = bronNaam.textContent;
        }
        menu.open = false;
        knop.focus();
      });

      // Dicht bij een tik ernaast of met Escape.
      this.klikErnaast = (event) => {
        if (menu.open && !menu.contains(event.target)) menu.open = false;
      };
      document.addEventListener('click', this.klikErnaast);
      menu.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && menu.open) {
          menu.open = false;
          knop.focus();
        }
      });
    }
  }

  if (!customElements.get('sticky-koopbalk')) {
    customElements.define('sticky-koopbalk', StickyKoopbalk);
  }

  } catch(e) { console.error(e); }
})();
})();
